module.exports = __webpack_public_path__ + "static/media/1200px-Star_Wars_Logo.svg.1faad84b.png";